
import BookSquare from "../../../assets/filled/BookSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BookSquareIcon({ className, dataTestid = "BookSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BookSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
